import ProjectExecutionPlanPage from "../../shared/project-execution-plan/ProjectExecutionPlanPage";

const ManagementProjectExecutionPlanPage = () => (
  <ProjectExecutionPlanPage source="Management" />
);

export default ManagementProjectExecutionPlanPage;
